import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Preloader.css';

export interface IPreloaderProps {
  size?: number;
  id?: string | number;
}

export const Preloader: React.FC<IPreloaderProps> = props => {
  const { id = styles['preloader'], size = 16 } = props;
  const gradientId = `preloader-gradient-${id}`;

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg
      data-testid="preloader"
      className={classNames(styles['preloader'])}
      style={{
        height: size,
        width: size,
      }}
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient id={gradientId} gradientUnits="userSpaceOnUse" y1="30" x2="40" y2="30">
          <stop offset="0" stopColor="#0076eb"></stop>
          <stop offset="1" stopColor="var(--theme-white)" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"
      ></path>
    </svg>
  );
};
